module.exports = __webpack_public_path__ + "img/deutsche bank.08ea63ff.png";